export const API_BASE_URLS = {
  krit: (process.env.VUE_APP_KRIT_API_URL || 'https://api.pms.lexcode.co.kr/krit').replace(/\/+$/, ''),
  papago: 'https://api.pms.lexcode.co.kr/papago',
  moj: 'https://api.pms.lexcode.co.kr/moj',
  test: 'https://api.pms.lexcode.co.kr/test'
}

const serviceByPrefix = {
  'krit-api': 'krit',
  'papago-api': 'papago',
  'moj-api': 'moj',
  test_board: 'test'
}

// 기존 화면의 API 경로를 서비스별 새 주소로 연결한다.
export const routeServiceRequest = (config) => {
  const match = config.url?.match(/^\/?([^/?#]+)(\/.*|\?.*|#.*|$)/)
  const service = match && serviceByPrefix[match[1]]
  if (service) {
    config.baseURL = API_BASE_URLS[service]
    config.url = match[2] || '/'
  }
  return config
}
